import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    userLogin: localStorage.getItem('userLogin') === 'true',
    locale: localStorage.getItem('locale') || 'en',
    scrollTarget: null
  },
  //end state,
  mutations: {
    setScrollTarget(state, target) {
      state.scrollTarget = target
    },
    dataLogin(state, data) {
      state.userLogin = data
      localStorage.setItem('userLogin', data)
      console.log(state.userLogin)
    },
    setLocale(state, locale) {
      state.locale = locale
      localStorage.setItem('locale', locale)
    }
  }, //end mutations
  actions: {} //end actions
})
